import axios from 'axios';
import { host } from '../../helper/config';

export function recipientPhone(value) {
  const phone = value.trim().replace(/[\s()+.-]/g, '').replace(/^84(?=[35789]\d{8}$)/, '0');
  if (!/^0[35789]\d{8}$/.test(phone)) throw new Error('Nhập số điện thoại di động Việt Nam, dạng 0… hoặc +84…');
  return phone;
}

/** Existing read-only Admin customer search; never uses balance or account mutation routes. */
export async function findNotificationRecipients(token, value) {
  const phone = recipientPhone(value);
  let response;
  try {
    response = await axios.post(`${host}/admin-users/get-all`, { phone: phone.slice(1), page: 0, itemPerPage: 100 },
      { headers: { Authorization: token, 'Content-Type': 'application/json' }, timeout: 15000 });
  } catch (error) {
    throw new Error(error.response?.status === 401 ? 'Phiên Admin đã hết hạn. Vui lòng đăng nhập lại.'
      : error.response?.status === 403 ? 'Phiên Admin không được phép tra khách hàng.' : 'Không thể tìm khách hàng. Vui lòng thử lại.');
  }
  const payload = response.data;
  if (response.status !== 200 || !Array.isArray(payload?.data) || !Number.isInteger(payload.total) || payload.total < 0) {
    throw new Error('Dữ liệu tìm khách hàng chưa hợp lệ. Vui lòng thử lại.');
  }
  if (payload.total > payload.data.length) throw new Error('Kết quả tìm kiếm chưa đầy đủ. Hãy lấy ID chính xác tại Quản lý khách hàng.');
  return payload.data.filter(row => {
    try { return recipientPhone(row.phone || '') === phone && typeof row.id === 'string' && row.id.length > 0 && row.id.length <= 128; }
    catch { return false; }
  }).map(row => ({ id: row.id, phone: row.phone, name: row.name || 'Khách hàng', active: row.status === 1 }));
}
